import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auto-authorization-setting-asd',
  templateUrl: './auto-authorization-setting-asd.component.html',
  styleUrls: ['./auto-authorization-setting-asd.component.scss']
})
export class AutoAuthorizationSettingAsdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
